import { Component, OnInit, Input, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { timer } from 'rxjs/observable/timer';
import { debounce } from 'rxjs/operators';
import { ChatService } from './ai-chat.service';
@Component({
  selector: 'app-ai-chat',
  templateUrl: './ai-chat.component.html',
  styleUrls: ['./ai-chat.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AiChatComponent implements OnInit {
  @Input() chatId: number | null = 0;
  @Input() widgetMode: boolean = true;
  isEditingTitle: boolean = false;
  expandDashboard:boolean=false;
  chatForm: FormGroup;
  chatName: string = "New Chat";
  messages: any[] = [];
  chatHistory: any = {};
  isTemplateVisible: boolean = true;
  showButtons: boolean = false;
  chatHistoryCurrentChatId: number;
  messageLoading : boolean = false;
  hideChatbotTerms : boolean = false;
  imgPath : string = "assets/images/";
  @ViewChild('chatWindowValue') private chatWindowValue: ElementRef;

  private typingSubject = new Subject<string>();
  currentImage: string = this.imgPath + 'idle-0.png'; // Start with the ideal image

  constructor(private chatService: ChatService, private fb: FormBuilder) {
    this.chatForm = this.fb.group({
      userInput: [''],
      indexName: [''],
      chatId: [this.chatId],
      userId: [1]
    });
  }

  onInput(event: Event): void {
    this.currentImage = this.imgPath + "listening.png";
    this.typingSubject.next();
  }

  scrollToBottom(): void {
    setTimeout(() => {
      const container = this.chatWindowValue.nativeElement;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    }, 500);
  }

  ngOnInit() {
    this.typingSubject.pipe(
      debounce(() => timer(500))
    ).subscribe(() => {
      // After debounce time, switch to ideal image
      this.currentImage = this.imgPath + "idle-0.png";
      setTimeout(() => {
        this.currentImage = this.imgPath + "idle-1.png";
      }, 2 * 60 * 1000);
    });

    this.loadChatData(0);
    this.scrollToBottom();
    this.typingSubject.next();
  }

  loadChatData(chatId:number): void {
      this.chatService.getChat(chatId).subscribe(data => {
         this.chatName = data.currentChat.name || "New Chat";
         this.messages = data.currentChat.messages || [];
         this.chatHistory = data.chatHistory;
         this.chatId = data.chatId;
         this.chatForm.controls.chatId.setValue(data.chatId);
         this.widgetMode = true;
         this.hideChatbotTerms = data.chatbotTerms;
         this.scrollToBottom();
         setTimeout(() => {
           if(this.messages.length==0){
            var chatElement = document.querySelector('#ai-chat-' + data.chatId + ' #chat-window #messageContainer');
            var elementChildLength = chatElement.children.length;
            for(let i = 0; i < elementChildLength; i++){
              if(chatElement.children[0].innerHTML != ""){
                chatElement.children[0].remove();
              }
            }
          }
         });
      });
  }

  UpdateChatTitle(chatId, title, isChatHistory): void {
    if (chatId > 0) {
      this.chatService.updateChatTitle(chatId, title).subscribe((data) => {
          if(isChatHistory){
            this.toggleEditHistoryTitle(chatId)
          }else{
          this.chatName = data.currentChat.name || "New Chat";
          this.chatHistory = data.chatHistory;
          this.toggleEditChatTitle();
        }
        });
    }
  }

  toggleEditHistoryTitle(chatId){
    if(this.chatHistoryCurrentChatId == chatId){
      this.chatHistoryCurrentChatId = 0;
    }else{
      this.chatHistoryCurrentChatId = chatId
    }
  }

  startNewChat(): any {
    this.chatService.startNewChat().subscribe((data) => {
       this.messages = data.currentChat.messages || [];
       this.chatHistory = data.chatHistory;
       this.chatName = data.currentChat.name
       this.chatId = data.currentChat.positiveAI_ChatId;
       this.isTemplateVisible=true;
       this.hideChatbotTerms = data.chatbotTerms;
       this.chatForm.controls.chatId.setValue(data.currentChat.positiveAI_ChatId);
       setTimeout(() => {
        var chatElement = document.querySelector('#ai-chat-' + data.currentChat.positiveAI_ChatId + ' #chat-window #messageContainer');
        var elementChildLength = chatElement.children.length;
        for(let i = 0; i < elementChildLength; i++){
          if(chatElement.children[0].innerHTML != ""){
            chatElement.children[0].remove();
          }
        }
       });
    });
  }

  deleteChat(chatId, currentChatId): void {
    if (chatId) {
      this.chatService.deleteChat(chatId, currentChatId).subscribe((data) => {
        this.loadChatData(data.chatId);
      });
    }
  }

  toggleEditChatTitle(){
    this.isEditingTitle = !this.isEditingTitle;
  }

  sendMessage(msg): void {

    if(msg != null && msg != ""){
      this.chatForm.controls.userInput.setValue(msg);
    }

    if (this.chatForm.valid && this.chatForm.controls.userInput.value != "") {
      this.currentImage = this.imgPath + `thinking.png`;
      var chatElement = document.querySelector('#chat-window #messageContainer');
      chatElement.appendChild(this.chatService.buildMessage(this.chatForm.get('userInput').value, false));
      this.isTemplateVisible=false;
      this.messageLoading = true;
      this.scrollToBottom();
      this.chatService.sendMessage(this.chatForm.value).subscribe(response => {
        this.messageLoading = false;
        const chatContId = `ai-chat-${response.chatId}`;
        if (document.getElementById('ai-chat-0') != null) document.getElementById('ai-chat-0').setAttribute("id", chatContId);
        if(document.getElementById(chatContId) != null){
          document.getElementById(chatContId).querySelector('#chatId')!.setAttribute('value', response.chatId);
          var messageElement = this.chatService.buildMessage(response.message, true);
          chatElement.appendChild(messageElement);
          this.chatName = response.chatName;
          this.chatHistory = response.chatHistory;
          this.chatForm.controls.userInput.setValue("");
           this.isTemplateVisible=false;
           this.scrollToBottom();
           this.currentImage = this.imgPath + `success-`+this.getRandInc(0, 1)+`.png`;
           setTimeout(() => {
             this.typingSubject.next();
            }, 3000)
        }
      });
    }
  }

  public handleBotResponse(result: any): void {
    const chatContId = `ai-chat-${result.ChatId}`;
    if(document.getElementById(chatContId) != null){
      document.getElementById(chatContId).querySelector('#chatId')!.setAttribute('value', result.ChatId);
      document.getElementById(chatContId).appendChild(this.chatService.buildMessage(result.Message, true));
    }
  }

  public openChatHistory(){
     this.widgetMode = !this.widgetMode;
  }

  public getRandInc(min, max) {
    // Gets random int inclusive of min and max
    const minCeiled = Math.ceil(min);
    const maxFloored = Math.floor(max);
    return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled);
}

}



// WEBPACK FOOTER //
// ./src/app/components/ai-chat/ai-chat.component.ts